import { render, staticRenderFns } from "./RoomCBTList.vue?vue&type=template&id=1ad2777a&scoped=true&"
import script from "./RoomCBTList.vue?vue&type=script&lang=js&"
export * from "./RoomCBTList.vue?vue&type=script&lang=js&"
import style0 from "./RoomCBTList.vue?vue&type=style&index=0&id=1ad2777a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad2777a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad2777a')) {
      api.createRecord('1ad2777a', component.options)
    } else {
      api.reload('1ad2777a', component.options)
    }
    module.hot.accept("./RoomCBTList.vue?vue&type=template&id=1ad2777a&scoped=true&", function () {
      api.rerender('1ad2777a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTList.vue"
export default component.exports